export interface ModalDeliveryShareModel {
  distributionKeyCode: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  reasonForSharing: string;
  userEvent: string;
}

export interface SharedReason {
  deliverySharedReasonNm: string;
  deliverySharedReasonId?: number;
}
